<script setup lang="ts">
  import { RouterView } from 'vue-router';
  import NavBar from "@/components/navigation/NavBar.vue";
  import NavFooter from "@/components/navigation/NavFooter.vue";
  import { useAppStore } from "@/stores/app";
  import dots from '@/assets/images/dots-dynamic.svg';
  import { solveFilter } from '@/utils/filterSolver';
  import ReferralRockModal from "@/components/modals/ReferralRockModal.vue";
  import SubscriptionFlowModal from "@/components/modals/subscription_flow/SubscriptionFlowModal.vue";
  import { useSubscriptionFlowStore } from "@/stores/subscriptionFlow";
  import SweepstakesReminder from "@/components/SweepstakesReminder.vue";
  import { onMounted } from "vue";
  import SweepstakesNumbersModal from "@/components/modals/sweepstakes/SweepstakesNumbersModal.vue";
  import CardExistModal from '@/components/modals/CardExistModal.vue';
  import Notices from "@/components/notices/Notices.vue";

  const filter = solveFilter('--v-theme-blue-500');
  const appStore = useAppStore();
  const subscriptionFlowStore = useSubscriptionFlowStore();

  onMounted(async () => {
    await appStore.fetchMembershipTiers();
  });

</script>

<template>
  <v-layout class="layout">
    <div v-if="appStore.showDuotoneBackground" class="app-background">
      <div v-if="appStore.showDuotoneBackgroundDots" class="dots"
           :style="{ 'background-image': 'url(' + dots + ')' }"></div>
    </div>
    <notices></notices>
    <nav-bar/>
    <v-main>
      <router-view/>
    </v-main>
    <nav-footer/>
  </v-layout>

  <ReferralRockModal v-if="!appStore.client!.featureFlags.newReferralSystem"/>
  <CardExistModal/>

  <SweepstakesReminder/>
  <SweepstakesNumbersModal v-model="appStore.showSweepStakesModal"/>

  <!-- Subscription Flow Modal -->
  <SubscriptionFlowModal v-if="subscriptionFlowStore.showModal"/>
</template>

<style lang="scss" scoped>
  .layout {
    display: flex;
    flex-direction: column;
  }

  .app-background {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -10;
    height: 558px;
    width: 100%;
    background-color: rgb(var(--v-theme-neutral-100));

    .dots {
      position: absolute;
      min-height: 229px;
      height: 229px;
      width: 100%;
      max-width: 90%;
      left: 50%;
      bottom: 0;
      transform: translate(-50%, 50%);
      background-repeat: repeat;
      background-size: 40px;
      background-position-y: -8px;
      background-position-x: 10px;
      filter: v-bind(filter);
      -webkit-filter: v-bind(filter);
      opacity: 0.2;
    }
  }

  @media screen and (max-width: breakpoint(md) - 1px) {
    .app-background {
      .dots {
        max-width: 100%;
      }
    }
  }
</style>
